import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, ShieldCheck, Ruler, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#061970] text-white pt-16 pb-8 border-t-4 border-[#FF7F32] font-sans">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <div>
              <h3 className="text-3xl font-black italic tracking-tighter mb-2">MRC</h3>
              <p className="text-[#FF7F32] font-bold uppercase tracking-widest text-sm">Protección en Movimiento</p>
            </div>
            <p className="text-gray-300 max-w-xs leading-relaxed">
              Diseñados para la velocidad, construidos para la seguridad. Tu mejor aliado en cada curva y recta del camino.
            </p>
            <div className="flex gap-4"> 
              <a href=" https://www.instagram.com/mrc_mexico/" target='_blank' className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FF7F32] transition-colors group">
                <Instagram className="w-5 h-5 text-white group-hover:scale-110 transition-transform" />
              </a>
            </div>
          </div>

          {/* Support Column */}
          <div className="space-y-6">
            <h4 className="text-xl font-bold uppercase italic tracking-wider border-b border-[#FF7F32]/30 pb-2 inline-block">Soporte</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/guia-de-tallas" onClick={handleLinkClick} className="flex items-center gap-2 text-gray-300 hover:text-[#FF7F32] transition-colors group">
                  <Ruler className="w-4 h-4 group-hover:text-[#FF7F32]" />
                  Guía de Tallas
                </Link>
              </li>
              <li>
                <Link to="/certificaciones" onClick={handleLinkClick} className="flex items-center gap-2 text-gray-300 hover:text-[#FF7F32] transition-colors group">
                  <ShieldCheck className="w-4 h-4 group-hover:text-[#FF7F32]" />
                  Certificaciones de Seguridad
                </Link>
              </li>
              <li>
                <Link to="/contacto" onClick={handleLinkClick} className="flex items-center gap-2 text-gray-300 hover:text-[#FF7F32] transition-colors group">
                  <FileText className="w-4 h-4 group-hover:text-[#FF7F32]" />
                  Información de Garantía
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="space-y-6">
            <h4 className="text-xl font-bold uppercase italic tracking-wider border-b border-[#FF7F32]/30 pb-2 inline-block">Contacto</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="mt-1 w-8 h-8 rounded bg-[#FF7F32]/20 flex items-center justify-center shrink-0">
                  <Mail className="w-4 h-4 text-[#FF7F32]" />
                </div>
                <div>
                  <p className="text-sm text-gray-400 uppercase tracking-wider mb-1">Correo Electrónico</p>
                  <a href="mailto:contacto@bewell.mx" className="text-lg font-bold hover:text-[#FF7F32] transition-colors">
                    contacto@bewell.mx
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="mt-1 w-8 h-8 rounded bg-[#FF7F32]/20 flex items-center justify-center shrink-0">
                  <Phone className="w-4 h-4 text-[#FF7F32]" />
                </div>
                <div>
                  <p className="text-sm text-gray-400 uppercase tracking-wider mb-1">Llámanos</p>
                  <a href="tel:+525563168297" className="text-lg font-bold hover:text-[#FF7F32] transition-colors">
                    +52 55 6316 8297
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>© 2026 MRC Racing. Todos los derechos reservados.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/privacidad" onClick={handleLinkClick} className="hover:text-white transition-colors">Privacidad</Link>
            <Link to="/terminos" onClick={handleLinkClick} className="hover:text-white transition-colors">Términos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
